var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230.13,
    cy: 230.131,
    r: 229.679,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.859 329.662C225.034 329.675 220.411 331.604 217.008 335.023C213.604 338.443 211.697 343.073 211.705 347.898C211.716 352.724 213.639 357.349 217.053 360.755C220.47 364.164 225.1 366.074 229.926 366.071C234.751 366.068 239.376 364.148 242.787 360.734C246.199 357.319 248.114 352.692 248.114 347.866C248.114 343.041 246.191 338.392 242.766 334.975C239.341 331.561 234.697 329.649 229.861 329.662H229.859ZM229.859 357.167C227.397 357.141 225.047 356.14 223.324 354.385C221.598 352.63 220.641 350.262 220.657 347.8C220.675 345.338 221.667 342.985 223.417 341.254C225.167 339.523 227.53 338.555 229.992 338.565C232.454 338.573 234.812 339.558 236.548 341.299C238.288 343.044 239.261 345.404 239.261 347.866C239.248 350.347 238.25 352.721 236.487 354.465C234.724 356.21 232.339 357.183 229.859 357.17V357.167Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.854 107.657H249.864C251.651 107.657 253.302 106.705 254.196 105.156C255.089 103.608 255.089 101.701 254.196 100.154C253.302 98.6072 251.651 97.6523 249.864 97.6523H209.854C208.067 97.6523 206.416 98.6046 205.522 100.154C204.629 101.701 204.629 103.608 205.522 105.156C206.416 106.703 208.067 107.657 209.854 107.657V107.657Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.879 385.164C313.808 385.164 317.577 383.625 320.383 380.877C323.189 378.127 324.802 374.388 324.882 370.461V89.7518C324.792 85.8335 323.17 82.1072 320.367 79.3679C317.563 76.6285 313.8 75.0975 309.879 75.0975H149.839C145.955 75.1615 142.248 76.7299 139.495 79.4719C136.742 82.2139 135.163 85.9162 135.086 89.8024V370.509C135.177 374.385 136.764 378.074 139.511 380.805C142.261 383.537 145.963 385.097 149.839 385.161H309.879V385.164ZM145.088 370.509V89.7464C145.088 88.4208 145.617 87.1485 146.553 86.2096C147.492 85.2707 148.764 84.7452 150.09 84.7452H309.879C311.204 84.7452 312.477 85.2733 313.415 86.2096C314.354 87.1485 314.88 88.4208 314.88 89.7464V370.509C314.88 371.835 314.352 373.107 313.415 374.046C312.477 374.985 311.204 375.511 309.879 375.511H149.839C148.556 375.447 147.348 374.892 146.462 373.961C145.577 373.03 145.086 371.795 145.086 370.509H145.088Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.165 273.2C261.04 273.891 262.155 274.205 263.259 274.072C264.366 273.939 265.374 273.373 266.065 272.498C266.769 271.629 267.089 270.511 266.959 269.399C266.825 268.289 266.252 267.278 265.364 266.596C261.448 263.52 259.005 258.943 258.626 253.979C258.247 249.015 259.973 244.121 263.376 240.488C266.783 236.858 271.554 234.82 276.534 234.878C281.512 234.934 286.238 237.082 289.556 240.789C292.877 244.499 294.488 249.431 293.995 254.387C293.501 259.343 290.951 263.862 286.966 266.844C286.07 267.502 285.475 268.492 285.318 269.591C285.158 270.69 285.446 271.81 286.118 272.696C286.91 273.752 288.148 274.382 289.468 274.398C290.388 274.39 291.279 274.093 292.018 273.547C298.625 268.636 302.506 260.874 302.471 252.64C302.477 243.625 297.841 235.241 290.199 230.456C282.56 225.671 272.995 225.156 264.884 229.096C256.775 233.035 251.267 240.872 250.307 249.837C249.346 258.799 253.07 267.628 260.16 273.195L260.165 273.2Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.103 247.193V273.051C203.103 286.846 210.462 299.59 222.409 306.488C234.353 313.386 249.074 313.386 261.019 306.488C272.963 299.593 280.325 286.846 280.325 273.051V263.55C283.792 262.229 286.435 259.356 287.465 255.793C288.495 252.229 287.788 248.388 285.558 245.425C283.328 242.462 279.834 240.717 276.126 240.717C272.419 240.717 268.924 242.462 266.695 245.425C264.465 248.388 263.758 252.229 264.787 255.793C265.817 259.356 268.46 262.229 271.928 263.55V273.152C271.928 283.944 266.169 293.917 256.825 299.313C247.482 304.709 235.964 304.709 226.618 299.313C217.272 293.917 211.516 283.944 211.516 273.152V247.095C223.679 245.881 234.961 240.197 243.177 231.141C251.389 222.086 255.953 210.307 255.977 198.083V178.878C255.977 167.424 254.177 156.174 241.675 150.871C240.547 148.113 238.68 145.723 236.279 143.957C233.878 142.191 231.038 141.124 228.072 140.868C225.151 140.442 222.185 141.218 219.846 143.018C217.509 144.819 215.999 147.489 215.663 150.42C215.327 153.352 216.197 156.294 218.067 158.574C219.798 160.812 222.396 162.21 225.218 162.426C226.167 162.474 227.119 162.474 228.069 162.426C232.169 162.799 236.244 161.5 239.373 158.825C244.825 161.375 247.626 165.925 247.626 178.83V197.984C247.626 212.617 239.819 226.14 227.146 233.457C214.474 240.773 198.859 240.773 186.187 233.457C173.514 226.14 165.707 212.62 165.707 197.984V178.881C165.707 166.477 168.908 161.676 174.458 158.876C177.582 161.316 181.508 162.495 185.461 162.178C186.411 162.226 187.363 162.226 188.313 162.178C191.151 161.978 193.77 160.577 195.514 158.326C197.427 155.933 198.259 152.853 197.814 149.823C197.405 146.95 195.866 144.36 193.535 142.632C191.207 140.903 188.278 140.178 185.41 140.62C178.86 141.671 172.607 145.622 171.658 151.124C161.655 155.525 157.305 163.927 157.305 178.782V197.936C157.31 210.414 162.034 222.427 170.532 231.566C179.03 240.704 190.67 246.289 203.116 247.196H203.114L203.103 247.193ZM276.321 249.045C277.716 249.045 278.975 249.885 279.508 251.176C280.042 252.464 279.746 253.95 278.762 254.937C277.775 255.924 276.289 256.22 275.001 255.684C273.71 255.15 272.869 253.891 272.869 252.496C272.869 250.592 274.414 249.045 276.321 249.045V249.045ZM225.759 154.021C225.271 153.952 224.836 153.677 224.559 153.272C224.063 152.711 223.841 151.959 223.959 151.22C224.185 149.929 225.354 149.022 226.658 149.118C229.299 149.337 231.745 150.596 233.46 152.618C233.409 153.618 230.459 154.469 225.756 154.168V154.018L225.759 154.021ZM187.051 149.02C188.267 149.057 189.281 149.964 189.451 151.17C189.555 151.9 189.355 152.642 188.902 153.221C188.606 153.632 188.155 153.901 187.651 153.97C182.951 154.32 179.998 153.421 179.9 152.719C181.62 150.484 184.234 149.113 187.051 148.969V149.02Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.85 179.726V187.477H188.299C187.182 187.464 186.104 187.901 185.314 188.694C184.525 189.486 184.085 190.561 184.098 191.678V205.132C184.098 206.242 184.541 207.306 185.33 208.085C186.12 208.867 187.187 209.296 188.297 209.283H195.848V217.234C195.848 218.349 196.291 219.416 197.077 220.205C197.864 220.995 198.934 221.435 200.049 221.435H213.703C214.818 221.435 215.885 220.992 216.674 220.205C217.464 219.419 217.904 218.349 217.904 217.234V209.483H224.855C225.965 209.496 227.034 209.064 227.821 208.285C228.611 207.506 229.053 206.442 229.053 205.332V191.678C229.067 190.561 228.629 189.483 227.837 188.694C227.045 187.904 225.97 187.464 224.852 187.477H217.851V179.726C217.851 178.611 217.408 177.544 216.621 176.755C215.834 175.965 214.764 175.525 213.649 175.525H199.846C198.766 175.576 197.75 176.042 197.003 176.824C196.256 177.606 195.842 178.646 195.845 179.726H195.85ZM204.252 191.678V183.927H209.504V191.678C209.518 192.788 209.963 193.85 210.75 194.634C211.534 195.421 212.596 195.866 213.705 195.879H220.707V201.131H213.705C212.591 201.131 211.524 201.574 210.734 202.361C209.945 203.148 209.504 204.217 209.504 205.332V213.233H204.252V205.13C204.215 204.009 203.724 202.953 202.895 202.201C202.065 201.449 200.969 201.062 199.851 201.129H192.5V195.877H199.851C200.998 195.933 202.121 195.514 202.951 194.719C203.783 193.924 204.252 192.825 204.252 191.676V191.678Z",
    fill: "url(#paint5_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 214.143,
    y1: 356.97,
    x2: 245.676,
    y2: 338.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 210.523,
    y1: 113.819,
    x2: 249.194,
    y2: 91.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 96.4311,
    y1: 307.238,
    x2: 363.535,
    y2: 153.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 253.627,
    y1: 265.638,
    x2: 298.932,
    y2: 239.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 178.774,
    y1: 248.356,
    x2: 272.149,
    y2: 194.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 186.429,
    y1: 210.286,
    x2: 226.962,
    y2: 186.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0E246F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0E406F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5A59A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#575CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4F67A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4279B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#18B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B7E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.1555128329c35205556ffbb134d94be7.svg";
export { ForwardRef as ReactComponent };